module.exports = __webpack_public_path__ + "img/card_background.f84faa25.png";